<template>
  <section id="users">
	<Notification corner="bottom-right" :closed="true" />
    <container textButton="ADICIONAR" :pathName="{ name: 'usuarioCreate' }">
		<div class="search-box">
			<span class="filter"><i class="fas fa-filter"></i> Filtros:</span>
			<div class="filter-section">
				<div class="search-section">
					<input
					type="text"
					placeholder="Pesquisar usuário"
					v-model.lazy="params.nome"
					@keyup.enter="getUsuarios"
					/>
					<label class="label-search" for="search" @click="getUsuarios">
						<i class="fas fa-search"></i>
					</label>
				</div>
				<div class="select-section">
					<v-select :options="perfis" :reduce="perfis => perfis.id" label="nome" v-model="perfilSelected" placeholder="Escolha o perfil"/>
				</div>
				<ButtonAction :onClick="getUsuarios"><span class="txt">FILTRAR</span></ButtonAction>
			</div>
		</div>
      <load-content v-if="loadContent" />
      <div class="table-wrapper" v-if="!loadContent && usuarios.length > 0">
        <div class="table">
          <table>
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Perfil</th>
                <th>Último acesso</th>
								<th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr class="fields" v-for="usuario in usuarios" :key="usuario.id">
                <td>
                  <span>{{ usuario.nome }}</span>
                </td>
                <td>
                  <span>{{ getUserProfile(perfis, usuario.perfil) }}</span>
                </td>
                <td>
                  <span>{{ formatDateAndTime(usuario.dataUltimoLogin) }}</span>
                </td>
								<td>
                  <item-status :status="usuario.flagAtivo"></item-status>
                </td>
                <td class="acoes">
									<div class="btn-container">
										<item-edit class="edit editar acao" routerName="usuarioEdit" :params="{ id: usuario.id  }"></item-edit>
										<button-remove class="delete" :onClick="() => selectHandler(usuario)"></button-remove>
									</div>
								</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginacao" v-if="totalItens > 20">
          <Pagination :totalItens="totalItens" :currentPage="paginaAtual" @pagina="getPaginaAtual" />
        </div>
      </div>

			<div v-else-if="!loadContent" class="objectNotFound">
					Nenhum usuário encontrado :)
			</div>
      <!-- Modal para confirmação de exclusão -->
      <Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
        <template v-slot:body>
          <p class="texto">
            Deseja remover o Usuário(a)
            <i>{{ removeItem.nome }}</i>?
          </p>
        </template>

        <template v-slot:footer>
          <button-action
            type="button"
            :onClick="() => remove(removeItem.id)"
            class="xs danger"
            style="margin-right: 10px;"
          >Confirmar</button-action>
          <button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
        </template>
      </Modal>
      <!-- Final exclusão-->
    </container>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { usuarios } from '@/services/usuarios'
import { formatDateAndTime } from '@/helpers/DateTime'
import { getUserProfile } from '@/helpers/GetUserProfile'

import Pagination from '@/components/shared/Pagination'
import container from '@/components/shared/Container'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import ButtonRemove from '@/components/shared/ButtonRemove'
import ItemStatus from '@/components/shared/ItemStatus'
import ItemEdit from '@/components/shared/ItemEdit'
import LoadContent from '@/components/shared/LoadContent'
import vSelect from 'vue-select'

export default {
	name: 'UsuariosList',
	components: {
		container,
		Modal,
		ButtonAction,
		ButtonRemove,
		ItemStatus,
		ItemEdit,
		Pagination,
		LoadContent,
		vSelect
	},
	data () {
		return {
			params: {
				nome: '',
				perfil: ''
			},
			usuarios: [],
			isModalVisible: false,
			removeItem: {},
			totalItens: 0,
			paginaAtual: 1,
			loadContent: true,
			search: '',
			perfilSelected: ''
		}
	},
	async created () {
		this.getPaginaAtual()
		if (this.$route.params && this.$route.params.message) {
			window.notificationEM.open('', this.$route.params.message, 'success')
		}
	},
	methods: {
		async getPaginaAtual () {
			this.loadContent = true
			this.params = {
				...this.params,
				...this.$route.query
			}

			if (this.params && this.params.skip) {
				this.paginaAtual = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.paginaAtual = 1
				this.params.skip = 0
			}

			this.usuarios = []

			await usuarios
				.find(this.params)
				.then(res => {
					(this.usuarios = res.data)
					this.totalItens = res.data[0].totalDeUsuarios
					this.loadContent = false
				})
				.catch(err => {
					console.log(err)
					this.loadContent = false
				})
		},
		closeModal () {
			this.isModalVisible = false
		},
		selectHandler (data) {
			this.isModalVisible = true
			this.removeItem = data
		},
		formatDateAndTime (date) {
			return formatDateAndTime(date)
		},
		getUserProfile (perfis, id) {
			return getUserProfile(perfis, id)
		},
		async remove (id) {
			this.isModalVisible = false
			this.loadContent = true
			try {
				await usuarios.delete(id)
				// this.usuarios = this.usuarios.filter(usuario => usuario.id !== id)
				if (parseInt(this.removeItem.totalDeUsuarios - 1) % 20 === 0) {
					const query = { skip: this.$route.query.skip - 1 }
					this.$router.replace({ query })
					this.params.skip = this.$route.query.skip > 1 ? this.$route.query.skip - 1 : 0
				}
				const retorno = await usuarios.find(this.params)
				this.usuarios = retorno.data
				this.totalItens = retorno.data[0].totalDeUsuarios
				window.notificationEM.open('', 'Usuário Excluído com sucesso!', 'success')
			} catch (error) {
				window.notificationEM.open('', error.response.data.msg, 'error')
			}
			this.removeItem = {}
			this.loadContent = false
		},
		async getUsuarios () {
			this.loadContent = true
			this.params.skip = 0
			this.params.perfil = this.perfilSelected

			await usuarios
				.find(this.params)
				.then(res => {
					this.usuarios = res.data
					this.totalItens = res.data[0].totalDeUsuarios
					this.paginaAtual = 1
					this.loadContent = false
				})
				.catch(err => {
					console.log(err)
					this.loadContent = false
				})
		}
	},
	computed: {
		...mapState({ perfis: state => state.perfis.list })
	}
}
</script>

<style lang="scss" scoped>

.search-box{
	background-color: $main-color;
	border-radius: 5px;
	padding: 20px 10px;
	margin-top: 20px;

	.filter {
		font-size: $font-size;
		color: #fff;
	}

	.filter-section {
		display: flex;
		justify-content: space-between;

		.search-section {
			padding: 0px 10px 0px 0px;
			width: 50%;
		}

		.select-section {
			width: 30%;
		}

		button {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 20px;
			height: 45px;
			width: 15%;
			padding: 0px;
			cursor: pointer;

			.txt {
				cursor:unset;
			}
		}
	}
}

.label-search{
	cursor: pointer;
}

.objectNotFound {
	margin-top: 50px;
	color: #000;
	text-align: center;
}
</style>
